<template>
  <OverviewWrapper>
    <AppCard :title="$t('All Users')" title-actions>
      <template #titleActions>
        <div class="d-flex flex-column flex-md-row align-end align-md-center justify-end">
          <v-text-field
            v-model="search"
            class="mb-4 mb-md-0 mr-md-4"
            outlined
            hide-details="auto"
            dense
            type="text"
            label="Search User"
            style="max-width: 200px"
            prepend-inner-icon="mdi-magnify"
          />
          <v-btn to="Users/create" color="secondary" rounded dark>
            <v-icon>mdi-plus</v-icon>
            <span class="d-none d-sm-inline">User erstellen</span>
          </v-btn>
        </div>
      </template>

      <AppPagination v-if="pagination" :pagination="pagination" location="top" />

      <v-data-table
        class="v-data-table__overview"
        :headers="headers"
        :items="users"
        :page="pagination.page"
        :items-per-page="pagination.perPage"
        :loading="pending"
        hide-default-footer
        :item-class="item => (!item.active ? 'grey lighten-4' : '')"
      >
        <template #[`item.client_id`]="{ item }">
          <router-link :to="{ name: 'clients-item', params: { id: item.client_id } }">
            {{ item.client_id }}
          </router-link>
        </template>

        <template #[`item.actions`]="{ item }">
          <OverviewActions type="users" :item-id="item.id" info edit remove @onRemove="remove" />
        </template>
      </v-data-table>

      <AppPagination v-if="pagination" :pagination="pagination" />
    </AppCard>
  </OverviewWrapper>
</template>

<script>
import { defineComponent, ref, computed, watch } from '@vue/composition-api'

import OverviewWrapper from '@/layouts/OverviewWrapper'
import AppCard from '@/components/UI/AppCard'
import AppPagination from '@/components/UI/AppPagination'
import OverviewActions from '@/components/UI/OverviewActions'

export default defineComponent({
  name: 'ViewUsers',
  components: {
    OverviewWrapper,
    AppCard,
    AppPagination,
    OverviewActions,
  },
  setup(props, { root: { $store, $route, $router }, root }) {
    const page = ref(1)
    const search = ref(null)
    const headers = [
      {
        sortable: false,
        text: 'Username',
        value: 'username',
      },
      {
        sortable: false,
        text: 'E-Mail',
        value: 'email',
      },
      {
        sortable: false,
        text: 'Rolle',
        value: 'role',
      },
      {
        sortable: false,
        text: 'Client',
        value: 'client_id',
      },
      {
        sortable: false,
        text: 'Actions',
        value: 'actions',
        align: 'right',
        width: '165px',
      },
    ]

    const activeQuery = computed(_ => root.$route.query)

    // store
    const pending = computed(_ => $store.state.users.pending)
    const users = computed(_ => $store.state.users.users)
    const pagination = computed(_ => $store.state.users.pagination)
    const getUsers = payload => $store.dispatch('users/getUsers', payload)
    const removeUser = userId => $store.dispatch('users/removeUser', userId)
    const addToast = toast => $store.commit('notifications/ADD_TOAST', toast)

    page.value = $route.query.page || page.value
    getUsers({ page: page.value })

    watch(activeQuery, value => {
      page.value = value.page ? value.page : 1
      clearTimeout(delayTimer)
      getUsersWithParams()
    })

    const delayTimer = ref(null)
    watch(search, _ => {
      clearTimeout(delayTimer.value)
      delayTimer.value = setTimeout(() => {
        page.value = 1
        getUsersWithParams()
      }, 500)
    })

    const getUsersWithParams = _ => {
      const params = {
        page: page.value,
      }

      if (search.value) {
        params.search = search.value
      }

      getUsers(params)
    }

    const remove = id => {
      if (confirm('Sicher, dass der Nutzer gelöscht werden soll?')) {
        if (pending.value) {
          return
        }
        removeUser(id)
          .then(_ => {
            addToast({
              msg: 'Nutzer erfolgreich gelöscht',
              type: 'success',
            })

            if (pagination.value.current === 1 && page.value !== 1) {
              $router.push({ query: { page: page.value - 1 } })
            } else {
              getUsers(page.value)
            }
          })
          .catch(error => {
            addToast({
              msg: 'Löschung fehlgeschlagen',
              type: 'error',
            })
          })
      }
    }

    return {
      pending,
      search,
      users,
      headers,
      pagination,
      remove,
    }
  },
})
</script>
